import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppRouter from './components/AppRouter'; // Changed from App to AppRouter
import './i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppRouter />
  </React.StrictMode>
);
